<template>
  <div class="login_layout">
    <div class="tabs">
      <a :class="tags == 0 ? 'active' : ''" @click="handleTabs(0)">短信登录</a>
      <a :class="tags == 1 ? 'active' : ''" @click="handleTabs(1)">密码登录</a>
    </div>
    <div class="center" >

        <div class="input_item">
          <input class="input" v-model="formItem.username" placeholder="请输入手机号" name="username" type="text" />
        </div>

        <div class="wxl_input_c" v-show="tags == 0">
          <div id="wxl_login" v-if="reloadWxl"></div>
        </div>

        <div class="wxl_input_c" v-show="tags == 1 && reloadWxl2">
          <div id="wxl_login2" v-if="reloadWxl2"></div>
        </div>

        <div class="input_item input_item_code" v-show="tags == 0" >
          <input class="input" placeholder="验证密码" maxlength="12" v-model="formItem.msgCode" name="code" type="p" />
          <a  :class="{sub:true,times:limitTime!= 61}" @click="handleSendMsgNew">{{limitTime!= 61 ? `${limitTime}s后重发` :'获取验证码'}}</a>
        </div>

        
        <div class="input_item input_item_password" v-show="tags == 1" >
          <input class="input" placeholder="密码" v-model="formItem.password" name="password" type="password" />
        </div>  

        <button class="input_submit" @click="submitLogin">
          立即登录
        </button>
        <!-- <div :class="{checkbox:true,yes:formItem.checkbox==1}"><label><input type="checkbox" v-model="formItem.checkbox" name="checkbox" value="1" checked="checked" /> 同意大淘客联盟使用商品记录生成报告</label></div> -->
    </div>
    
  </div>
</template>

<script>
import {SetCookie} from '@/utils/utils'
export default {
  name: 'Login',
  data () {
    return {
      formItem:{
        username:'',
        password:'',
        msgCode:'',
        csessionid:'',
        sig:'',
        token:'',
        scene:'',
        captcha:'',
        // checkbox:0,
      },
      expressions : new RegExp("^[\\w\\-\\.]+@[\\w\\-\\.]+\\.\\w+$"),
      phoneReg : new RegExp("^1[3|4|5|6|7|8|9][0-9]\\d{8}$"),
      tags:0,
      noCaptchaConfig:{},
      reloadWxl:true,
      limitTime:61,
      reloadWxl2:false,
      TwdNoCaptchaConfig:{},
      loading:false,
      clearInt:null
    }
  },
  props:{
    onSuccess: Function, // 成功回调
  },
  mounted(){
   //注入 智能验证window变量，不可以修改变量名称切智能放在事例化方法的时候调用
    window.NVC_Opt = {
      appkey:'FFFF0000000001798134',
      scene:'ic_login',
      renderTo:'#login_layer_captcha',
      trans: {"key1": "code0", "nvcCode":200},
      elements: [
          '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png',
          '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png'
      ],
      bg_back_prepared: '//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png',
      bg_front: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC',
      obj_ok: '//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png',
      bg_back_pass: '//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png',
      obj_error: '//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png',
      bg_back_fail: '//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png',
      upLang:{"cn":{
          _ggk_guide: "请摁住鼠标左键，刮出两面盾牌",
          _ggk_success: "恭喜您成功刮出盾牌<br/>继续下一步操作吧",
          _ggk_loading: "加载中",
          _ggk_fail: ['呀，盾牌不见了<br/>请', "javascript:noCaptcha.reset()", '再来一次', '或', "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题'],
          _ggk_action_timeout: ['我等得太久啦<br/>请', "javascript:noCaptcha.reset()", '再来一次', '或', "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题'],
          _ggk_net_err: ['网络实在不给力<br/>请', "javascript:noCaptcha.reset()", '再来一次', '或', "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题'],
          _ggk_too_fast: ['您刮得太快啦<br/>请', "javascript:noCaptcha.reset()", '再来一次', '或', "http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN", '反馈问题']
      }
      }
    };
    this.createCaptcha('#wxl_login',(item)=>{
      this.noCaptchaConfig = item;
    })
  },
  methods:{
    handleReLoad(){
      this[this.tags == 0 ? 'reloadWxl':'reloadWxl2'] = false;
      setTimeout(()=>{
        this[this.tags == 0 ? 'reloadWxl':'reloadWxl2'] = true;
       setTimeout(()=>{
         if(this.tags == 0){
            this.createCaptcha('#wxl_login',(item)=>{
              this.noCaptchaConfig = item;
            })
         }else{
            this.createCaptcha('#wxl_login2',(item)=>{
              this.TwdNoCaptchaConfig = item;
            })
         }
          
       },10)
      },10)
    },
    createCaptcha (id, callback) {
      // $(id).removeClass('nc-container').empty();
      var nc_appkey = 'FFFF0000000001798134';
      var nc_scene = 'register';  //场景,不可更改
      var nc_token = [nc_appkey, (new Date()).getTime(), Math.random()].join(':');
      /* 滑动验证 */

      var nc = new noCaptcha();
      //普通滑块验证


      nc.init({
        renderTo: id,//渲染到该DOM ID指定的Div位置
        appkey: nc_appkey,
        scene: nc_scene,
        token: nc_token,
        callback:  (data) => {// 校验成功回调
          var formItem = {
            sessionid: data.csessionid,
            sig: data.sig,
            token: nc_token,
            scene: nc_scene,
          }
          callback(formItem);
        }
      });
    },
    countdown(){
      clearInterval(this.clearInt)
      this.limitTime = 61;
      this.clearInt = setInterval(()=>{
        this.limitTime  = this.limitTime - 1;
        if(this.limitTime == 0){
          this.limitTime = 61;
          clearInterval(this.clearInt)
        }
      },1000)
    },
    beforeDestroy(){
      clearInterval(this.clearInt)
    },
    handleSendMsgNew(){
      if(this.limitTime != 61){
        return false;
      }
      if(this.formItem.username == ''){
        layer.msg('亲输入手机号！')
        return false;
      }

      if(!this.noCaptchaConfig.token){
        layer.msg('请完成滑块验证！')
        return false;
      }
      if(this.loading){
        return false;
      }
      this.loading = true;

      this.$services.getSendMsgNew({
          ...{
            phone: this.formItem.username,
            type: 'login',
          },
          ...this.noCaptchaConfig,
        }).then(res=>{
          
          this.countdown();
          this.loading = false;
        })
    },
    handleTabs(index){
      this.tags = index;
    },
    submitLogin(){
      let sendData = {
        phone: this.formItem.username,
        loginType: this.tags == 0 ? 'msg' :'pwd',
        client_type: 'pc',
      }
      if(this.formItem.msgCode == '' && this.tags == 0){
        layer.msg('请输入验证码')
        return false;
      }
      // if(this.formItem.checkbox != 1){
      //   layer.msg('请同意大淘客联盟使用商品记录生成报告')
      //   return false;
      // }
      this.$services.setLoginRe({
        ...sendData,
        ...(this.tags == 0 ? {msgCode:this.formItem.msgCode}:{password:this.formItem.password}),
        ...(this.tags == 0 ? this.noCaptchaConfig : this.TwdNoCaptchaConfig),
      }).then(res=>{
        
        if(res.code == 0 && this.tags == 1){
          this.handleReLoad()
        }else if(this.tags == 0){
          this.handleReLoad()
        }
        if(res.code != 1){
          layer.msg(res.msg)
          return false;
        }
        SetCookie('jaw_uid',res.data.AppToken);
        this.$emit('onSuccess',res.data)

      })
      return false;
    }
  }
}
</script>
<style>
  .login_layout .nc-container .nc_wrapper, .nc-container.tb-login .nc_wrapper{
    width: 100% !important;
  }
  .login_layout .nc_scale{
    height: 44px;
  }
  .login_layout .nc-container .nc_scale span.nc-lang-cnt{
    height: 44px; line-height: 44px;
  }
  .login_layout .nc-container .nc_scale span{
    height: 44px; line-height: 44px; width: 44px; border: 0; border-radius: 100px;
  }
  .login_layout .nc-container .nc_scale .nc_bg{
    padding-right: 18px; 
  }
  body .layui-layer-msg{
    left: 0 !important;
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    background: none !important;
    margin-top: -50px;
  }
  body .layui-layer-msg .layui-layer-content{
        min-width: 100px !important;
        background-color: rgba(0,0,0,.6) !important;
        color: #fff !important;
        border: none !important;
  }
</style>
<style scoped>

  .login_layout{
    
    border-radius: undefinedpx undefinedpx undefinedpx undefinedpx;
    opacity: 1;
    background: rgba(255,255,255,0.8);
    backdrop-filter: blur(10px);
    position: fixed;
    bottom: 0;
    width: 100%;
    min-height: 55%;
    border-radius: 20px 20px 0 0;
    left:0;
  }
  .login_layout .tabs{
    display: flex;justify-content: space-evenly;
    border-bottom: solid 1px #B6C3FF;
  }
  .login_layout .tabs a{
    display: block; width: 40%; line-height: 50px;
    color: #999999;font-size: 18px; text-align: center;
    border-bottom: solid 3px rgba(255,255,255,0);
  }
  .login_layout .tabs a.active{
    color: #1E6FFF;border-bottom: solid 3px #1E6FFF;

  }
  .login_layout .center{
    margin: 0 25px;  padding-top: 20px;
  }
  .login_layout .center .input_item{
    margin-bottom: 15px;
    border-radius: 1000px;
    background: #fff;
    height: 44px;
    display: flex;
    align-items: center;    
    justify-content: space-between;
  }
  .login_layout .wxl_input_c{
    border-radius: 1000px;
    background: #fff;
    height: 44px;
    margin-bottom: 15px;
    overflow: hidden;
  }
  .login_layout .input_item_code .input{
    border-radius: 100px 0 0 100px !important;
  }
  .login_layout .center .input_item .input{
    color: #aaa; text-indent: 1em; font-size: 15px; border: 0; background: none !important; scale: none;
    touch-action: manipulation;    outline: 0; width: 100%; height: 44px; border-radius: 44px;
  }
  .login_layout .center .input_item .sub{
    width: 10em; font-size: 16px; color: #1E6FFF; text-decoration: none; text-align: center;
  }
  .login_layout .center .input_item .sub.times{
    color: #666;
  }
  .input_submit{
    border-radius: 44px;
    opacity: 1;
    border: 1px solid #FFD59B;
    background: linear-gradient(90deg, rgba(1,126,255,1) 0%, rgba(133,203,254,1) 100%);
    color: #fff;
    text-align: center;
    line-height: 44px;
    display: block; width: 100%;
  }
  .checkbox{
    color: #666; font-size: 12px; display: flex; padding-top: 10px;
    align-items: center; height: 24px; position: relative;
  }
  .checkbox input{
    float: left; margin: 0 5px; position: absolute;top: 2px; opacity: 0; display: none;
  }
  .checkbox::before{
    content: '';
    display: block;
    width:14px;
    height: 14px;
    background: url(../assets/ck_1.png) no-repeat center / contain;
    border-radius: 50%; margin: 0 5px 0 5px; position: relative; top: -1px;
  }
  .checkbox.yes::before{
    background: url(../assets/ck.png) no-repeat center / contain;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue